import { contactUsService } from '@/services/api'
import { groupByArrayOfObject } from '@/common/arrays'

const initialStates = {
    status: 'LOADING',
    contactUsList: {},
    pagination: {
        no_paginate: false,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    params: {
        page: 1
    }
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setContactUsList(state, contacts) {
        state.status = 'SET_LIST'
        state.contactUsList = contacts
    },
    setPagination(state, pagination) {
        state.status = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    resetParams(state) {
        state.status = 'RESET_PARAMS'
        state.params = {
            page: 1
        }
    },
    updateContactUs(state, contactUs) {
        state.status = 'UPDATE'
        state.contactUsList[contactUs.id] = Object.assign({}, state.contactUsList[contactUs.id], contactUs)
    },
    error(state) {
        state.status = 'ERROR'
    },
}

const getters = {
    status: state   => state.status,
    contacts: state => state.contactUsList,
    contactsCount: state => Object.keys(state.contactUsList).length,
    contactById: state => id => state.contactUsList[id],
    params: state => state.params,
    pagination: state => state.pagination
}

const actions = {
    setParamsAndFetch({dispatch}, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({commit}, params) {
        commit('setParams', params)
    },
    resetParams({commit}) {
        commit('resetParams')
    },
    fetch({commit, state}, params) {
        params = Object.assign({}, state.params, params)

        commit('loading')

        return new Promise((resolve, reject) => {
            contactUsService.fetch(params)
                .then(response => {
                    const result = response.data
                    const contacts = groupByArrayOfObject(result.data, 'id')

                    commit('setContactUsList', contacts)
                    if (params.no_paginate) {
                        commit('setPagination', {
                            no_paginate: true
                        })
                    } else {
                        commit('setPagination', {
                            per_page: result.per_page,
                            current_page: result.current_page,
                            last_page: result.last_page,
                            no_paginate: false,
                        })
                        commit('setParams', {
                            page: result.current_page,
                        })
                    }
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    // edit({commit}, params) {
    //     commit('loading')

    //     return new Promise((resolve, reject) => {
    //         contactUsService.edit(params, params.id)
    //             .then(() => {
    //                 commit('updateContactUs', params)
    //                 resolve()
    //             })
    //             .catch(error => {
    //                 commit('error')
    //                 reject(error.response ? error.response.data : error.response)
    //             })
    //     })
    // }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}